import React from "react";
import { NavLink, Link } from "react-router-dom";
import { PropTypes } from "prop-types";
import { Nav } from "reactstrap";
// Components
import FoodList from "views/food/FoodList.js"
import DishList from "views/dish/DishList.js"
import Dashboard from "views/Dashboard.js"
import UserList from "views/user/UserList.js"
import DietList from "views/diet/DietList.js"
import MealList from "views/meal/MealList"
import DiagnosisList from "views/diagnosis/DiagnosisList"
import MenuEditor from "views/menu/MenuEditor";
// Util
import { hasRole } from '../../util/hasRole';
import { withTranslation } from 'react-i18next';
import Reports from "views/Reports";
import CompanyList from "views/company/CompanyList.js"
import AuditLogs from "views/AuditLogs";
import AllergenList from "views/allergens/AllergenList";
import FodmapList from "views/fodmap/FodmapList";
import medieteticLogo from 'assets/img/medietetic-logo.svg';
import SIDEBAR_ICONS from './sidebarIcons';

class Sidebar extends React.Component {
  constructor(props) {
    super(props);
    this.activeRoute.bind(this);
  }
  // verifies if routeName is the one active (in browser input)
  activeRoute(routeName) {
    return this.props.location.pathname.indexOf(routeName) > -1 ? "active" : "";
  }

  linkOnClick = () => {
    document.documentElement.classList.remove("nav-open");
  };

  renderNavIcon = (prop) => {
    if (!prop.iconKey || !SIDEBAR_ICONS[prop.iconKey]) {
      return null;
    }
    const isActive = this.activeRoute(prop.path) === "active";
    const icons = SIDEBAR_ICONS[prop.iconKey];
    return (
      <img
        src={isActive ? icons.selected : icons.unselected}
        alt=""
        className="sidebar-nav-icon-img"
      />
    );
  };

  render() {
    const { bgColor, t } = this.props;

    var routes = [];
    if (hasRole('ROLE_SUPER_ADMIN')) {
      routes = [
        { path: "/dashboard", name: t("dashboard"), iconKey: "dashboard", component: Dashboard, layout: "/admin" },
        { path: "/userList", name: t("user_list"), iconKey: "users", component: UserList, layout: "/admin" },
        { path: "/foodList", name: t("food_list"), iconKey: "foods", component: FoodList, layout: "/admin" },
        { path: "/dishList", name: t("dish_list"), iconKey: "dish", component: DishList, layout: "/admin" },
        { path: "/dietList", name: t("diet_list"), iconKey: "diet", component: DietList, layout: "/admin" },
        { path: "/mealList", name: t("meal_list"), iconKey: "meal", component: MealList, layout: "/admin" },
        { path: "/diagnosisList", name: t("diagnosis_list"), iconKey: "diagnoses", component: DiagnosisList, layout: "/admin" },
        { path: "/allergenList", name: t("allergens"), iconKey: "allergens", component: AllergenList, layout: "/admin" },
        { path: "/fodmapList", name: t("fodmaps"), iconKey: "foodmaps", component: FodmapList, layout: "/admin" },
        { path: "/menuEditor", name: t("menu_editor"), iconKey: "menuEditor", component: MenuEditor, layout: "/admin" },
        { path: "/reports", name: t("reports"), iconKey: "reports", component: Reports, layout: "/admin" },
        { path: "/companyList", name: t("company_list"), iconKey: "company", component: CompanyList, layout: "/admin" },
        { path: "/audits", name: t("audit_logs"), iconKey: "logs", component: AuditLogs, layout: "/admin" }
      ];
    } else if (hasRole('ROLE_ADMIN')) {
      routes = [
        { path: "/dashboard", name: t("dashboard"), iconKey: "dashboard", component: Dashboard, layout: "/admin" },
        { path: "/userList", name: t("user_list"), iconKey: "users", component: UserList, layout: "/admin" },
        { path: "/foodList", name: t("food_list"), iconKey: "foods", component: FoodList, layout: "/admin" },
        { path: "/dishList", name: t("dish_list"), iconKey: "dish", component: DishList, layout: "/admin" },
        { path: "/dietList", name: t("diet_list"), iconKey: "diet", component: DietList, layout: "/admin" },
        { path: "/mealList", name: t("meal_list"), iconKey: "meal", component: MealList, layout: "/admin" },
        { path: "/diagnosisList", name: t("diagnosis_list"), iconKey: "diagnoses", component: DiagnosisList, layout: "/admin" },
        { path: "/allergenList", name: t("allergens"), iconKey: "allergens", component: AllergenList, layout: "/admin" },
        { path: "/fodmapList", name: t("fodmaps"), iconKey: "foodmaps", component: FodmapList, layout: "/admin" },
        { path: "/menuEditor", name: t("menu_editor"), iconKey: "menuEditor", component: MenuEditor, layout: "/admin" },
        { path: "/reports", name: t("reports"), iconKey: "reports", component: Reports, layout: "/admin" }
      ];
    }
    else if (hasRole('ROLE_STUDENT')) {
      routes = [
        { path: "/dashboard", name: t("dashboard"), iconKey: "dashboard", component: Dashboard, layout: "/admin" },
        { path: "/foodList", name: t("food_list"), iconKey: "foods", component: FoodList, layout: "/admin" },
        { path: "/dishList", name: t("dish_list"), iconKey: "dish", component: DishList, layout: "/admin" },
        { path: "/dietList", name: t("diet_list"), iconKey: "diet", component: DietList, layout: "/admin" },
        { path: "/mealList", name: t("meal_list"), iconKey: "meal", component: MealList, layout: "/admin" }
      ]
    }

    return (
      <div className="sidebar sidebar-v2" data={bgColor}>
        <div className="logo">
          <Link
            to="/admin/dashboard"
            className="sidebar-logo-link"
            onClick={this.props.toggleSidebar}
          >
            <img
              src={medieteticLogo}
              alt="MeDietetic"
              className="sidebar-logo-img"
            />
          </Link>
        </div>
        <div className="sidebar-nav-scroll">
          <Nav>
            {routes.map((prop, key) => {
              if (prop.redirect) return null;
              return (
                <li
                  className={
                    this.activeRoute(prop.path) +
                    (prop.pro ? " active-pro" : "")
                  }
                  key={key}
                >
                  <NavLink
                    to={prop.layout + prop.path}
                    className="nav-link sidebar-nav-link"
                    activeClassName="active"
                    onClick={this.linkOnClick}
                  >
                    {this.renderNavIcon(prop)}
                    <p>{prop.name}</p>
                  </NavLink>
                </li>
              );
            })}
          </Nav>
        </div>
      </div>
    );
  }
}

Sidebar.defaultProps = {
  bgColor: "green",
  routes: [{}]
};

Sidebar.propTypes = {
  bgColor: PropTypes.oneOf(["primary", "blue", "green"]),
  routes: PropTypes.arrayOf(PropTypes.object),
  logo: PropTypes.shape({
    innerLink: PropTypes.string,
    outterLink: PropTypes.string,
    text: PropTypes.node,
    imgSrc: PropTypes.string
  })
};

export default withTranslation()(Sidebar);
